import { render, staticRenderFns } from "./minimal-player-selector.vue?vue&type=template&id=5ad6eeca&scoped=true"
import script from "./minimal-player-selector.vue?vue&type=script&lang=js"
export * from "./minimal-player-selector.vue?vue&type=script&lang=js"
import style0 from "./minimal-player-selector.vue?vue&type=style&index=0&id=5ad6eeca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad6eeca",
  null
  
)

export default component.exports